import { z } from "zod";

export const EmployeeImageSchema = z.string().optional();

export type EmployeeImageType = z.infer<typeof EmployeeImageSchema>;
